import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    schools: [
        {
            id: "123456",
            name: "אלון",
            city: "0",
            cityName: "תל אביב",
            classes: [
                {
                    "class": 3,
                    "ordinal": 1
                },
                {
                    "class": 3,
                    "ordinal": 2
                },
                {
                    "class": 4,
                    "ordinal": 1
                }]
        },
        {
            id: "654321",
            name: "הנדיב",
            city: "1",
            cityName: "הרצליה",
            classes: [
                {
                    "class": 5,
                    "ordinal": 1
                },
                {
                    "class": 5,
                    "ordinal": 2
                },
                {
                    "class": 5,
                    "ordinal": 6
                }]

        },
        {
            id: "123455",
            name: "תיכון למדעים ע\"ש אילן רמון",
            city: "2",
            cityName: "ירושלים",
            classes: [
                {
                    "class": 3,
                    "ordinal": 1
                },
                {
                    "class": 3,
                    "ordinal": 2
                },
                {
                    "class": 3,
                    "ordinal": 3
                }]

        },
    ]
};

const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
    }
})

export const permissionsAction = permissionsSlice.actions;
export default permissionsSlice;